import React from 'react'
import { Route } from 'react-router-dom'
import { Menu } from 'antd'
import TPSMappingScreen from './TPSMappingScreen'
import { genonDataScreens, genonMappingScreens } from './tps-screens'
import { pathTitleMap } from 'title'
import { GENON_CLIENT, LANYARD_CLIENT } from 'client'

const TPSMenu = ({
  onSelect,
  theme,
  selectedKeys,
  CLIENT,
  dataAccess,
  mappingAccess,
}) => {
  return (
    <Menu
      key="genon-tps"
      mode="vertical"
      onSelect={onSelect}
      theme={theme}
      selectedKeys={selectedKeys}
    >
      <Menu.SubMenu
        title="TPS Interface"
        // style={{ width: '130px', height: '64px', lineHeight: '64px' }}
      >
        {dataAccess &&
          getDataScreens({ CLIENT }).map(s => (
            <Menu.Item key={s}>{pathTitleMap[s]}</Menu.Item>
          ))}
        <Menu.Divider />
        {mappingAccess &&
          getMappingScreens({ CLIENT }).map(s => (
            <Menu.Item key={s}>{pathTitleMap[s]}</Menu.Item>
          ))}
        <Menu.Item key="tps-file-log">TPS File Log</Menu.Item>
      </Menu.SubMenu>
    </Menu>
  )
}

const getMappingScreens = ({ CLIENT }) => {
  switch (CLIENT) {
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return genonMappingScreens
    default:
      return []
  }
}

const getDataScreens = ({ CLIENT }) => {
  switch (CLIENT) {
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return genonDataScreens
    default:
      return []
  }
}

// eslint-disable-next-line no-unused-vars
const TPSContainer = ({ actionPermits, envConfig, CLIENT }) => (
  <React.Fragment>
    {[...getMappingScreens({ CLIENT }), ...getDataScreens({ CLIENT })].map(
      s => (
        <Route key={s} exact path={'/' + s} component={TPSMappingScreen} />
      )
    )}
  </React.Fragment>
)

export { TPSContainer, TPSMenu }
